import axios from 'axios'
import { email } from 'vuelidate/lib/validators';

const client = axios.create({
    baseURL: 'https://practiqe.somee.com/api/users',
    json: true
})
export default{
    async execute(method, resource, data){
        return client({
            method,
            url: resource,
            data
        }).then(req=>{
            return req.data
        }).catch(error => {
            console.log(error.response)
        });
    },
    login(data){
        return this.execute('post','/auth',data)
    },
    reg(data){
        return this.execute('post','/reg',data)
    },
    getlk(data){
        return this.execute('get',data)
    },
    getEmail(){
        return this.$store.state.email;
    }
}